/**
 * COMPONENT: c-spacer (Tier 3 — Full Web Component)
 * Creates vertical space between elements.
 *
 * Attributes:
 *   height — CSS height value (e.g. "4rem", "50px")
 *
 * Usage:
 *   <c-spacer height="4rem"></c-spacer>
 */

class CSpacer extends HTMLElement {
  connectedCallback() {
    let type = this.getAttribute('type') || 'blank';
    this.style.display = 'block';
    this.style.width = '100%';
    const raw = this.getAttribute('height') || '0';
    this.style.setProperty('--spacer-h', raw);

    if (type === 'blank') {
      this.style.height = 'var(--spacer-h)';

      // Flag large spacers for responsive scaling
      const px = parseFloat(raw) * (raw.includes('rem') ? 10 : 1);
      if (px >= 100) this.setAttribute('data-scale', '');
    } else if (type === 'loop') {
      this.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="91" height="20" fill="none" viewBox="0 0 91 20"><path fill="#22517a" d="M20.587 3.79C25.63 1.564 30.09-.45 36.074.088c3.16.285 6.312 1.187 8.687 2.75 1.374.902 2.513 2.05 3.221 3.436q.602.112 1.213.237c2.014.416 4.128.945 6.296 1.492 2.175.55 4.407 1.12 6.685 1.627 9.14 2.037 18.745 3.006 27.298-2.27a1.001 1.001 0 0 1 1.051 1.703c-9.266 5.715-19.564 4.574-28.784 2.52-2.312-.516-4.574-1.093-6.74-1.64-2.172-.549-4.246-1.067-6.211-1.473l-.108-.021c.063.42.093.855.081 1.306-.105 4.113-2.314 7.188-5.09 8.845-2.734 1.632-6.171 1.96-8.708.324-2.508-1.617-3.348-4.439-2.714-7.022.634-2.587 2.73-4.934 6.035-5.806 2.096-.553 4.457-.55 6.978-.246a8.5 8.5 0 0 0-1.601-1.342c-2.022-1.33-4.828-2.164-7.768-2.429-5.4-.486-9.409 1.292-14.5 3.54-5.09 2.247-11.112 4.882-20.302 5.752a1 1 0 0 1-.187-1.992c8.856-.837 14.635-3.36 19.68-5.589m25.96 4.262c-3-.489-5.599-.59-7.751-.022-2.619.69-4.148 2.495-4.603 4.348-.456 1.857.15 3.765 1.856 4.866 1.724 1.11 4.32 1 6.6-.36 2.24-1.338 4.03-3.814 4.115-7.18a5.3 5.3 0 0 0-.218-1.652"/></svg>`;
      this.style.display = 'flex';
      this.style.justifyContent = 'center';
      this.style.alignItems = 'center';
      this.style.marginTop = 'var(--spacer-h)';
      this.style.marginBottom = 'var(--spacer-h)';
    }
  }
}

window.customElements.define('c-spacer', CSpacer);
